import { render } from "./LandingFooter.vue?vue&type=template&id=62a68a88&scoped=true"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"

import "./LandingFooter.vue?vue&type=style&index=0&id=62a68a88&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/checkmarq-backend/checkmarq-backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a68a88"]])

export default __exports__